<template>
  <aside :class="['sidebar', themeClass]">
    <!-- Logo -->
    <div class="sidebar-logo">
      <img src="/logo_b.png" alt="SICECOM" class="sidebar-logo__imagen" />
    </div>

    <nav class="sidebar-nav">
      <!-- Dashboard -->
      <router-link to="/" class="sidebar-item" exact-active-class="sidebar-item--activo">
        <span class="sidebar-item__icono"><i class="bi bi-speedometer2"></i></span>
        <span class="sidebar-item__texto">Dashboard</span>
      </router-link>

      <!-- Notificaciones -->
      <router-link to="/notificaciones" class="sidebar-item" active-class="sidebar-item--activo">
        <span class="sidebar-item__icono"><i class="bi bi-bell"></i></span>
        <span class="sidebar-item__texto">Notificaciones</span>
      </router-link>

      <!-- Infraestructura (Hostinger) -->
      <router-link to="/infraestructura" class="sidebar-item" active-class="sidebar-item--activo">
        <span class="sidebar-item__icono"><i class="bi bi-hdd-network"></i></span>
        <span class="sidebar-item__texto">Infraestructura</span>
      </router-link>

      <!-- Empresas -->
      <div class="sidebar-seccion">
        <button type="button" class="sidebar-grupo" @click="toggleMenu('empresas')">
          <span class="sidebar-item__icono"><i class="bi bi-buildings"></i></span>
          <span class="sidebar-item__texto">Empresas</span>
          <i class="bi bi-chevron-right sidebar-grupo__chevron" :class="{ 'sidebar-grupo__chevron--abierto': expandedMenus.empresas }"></i>
        </button>
        <transition name="desplegable">
          <div v-show="expandedMenus.empresas" class="sidebar-submenu">
            <router-link to="/empresas" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-list-ul"></i> Lista</router-link>
            <router-link to="/empresas/nueva" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-plus-circle"></i> Nueva empresa</router-link>
            <router-link to="/empresas/subdominios" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-globe"></i> Subdominios</router-link>
            <router-link to="/empresas/usuarios" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-people"></i> Usuarios</router-link>
          </div>
        </transition>
      </div>

      <!-- Control de Acceso (sistema nuevo: modulos, planes y suscripciones) -->
      <div class="sidebar-seccion">
        <button type="button" class="sidebar-grupo" @click="toggleMenu('controlAcceso')">
          <span class="sidebar-item__icono"><i class="bi bi-shield-lock"></i></span>
          <span class="sidebar-item__texto">Control de acceso</span>
          <i class="bi bi-chevron-right sidebar-grupo__chevron" :class="{ 'sidebar-grupo__chevron--abierto': expandedMenus.controlAcceso }"></i>
        </button>
        <transition name="desplegable">
          <div v-show="expandedMenus.controlAcceso" class="sidebar-submenu">
            <router-link to="/control-acceso/modulos" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-diagram-3"></i> Módulos</router-link>
            <router-link to="/control-acceso/planes" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-layers"></i> Planes</router-link>
            <router-link to="/control-acceso/suscripciones" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-card-checklist"></i> Suscripciones</router-link>
            <router-link to="/control-acceso/comprobantes" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-file-earmark-check"></i> Comprobantes</router-link>
          </div>
        </transition>
      </div>

      <!-- Facturacion de planes (SRI) -->
      <div class="sidebar-seccion">
        <button type="button" class="sidebar-grupo" @click="toggleMenu('facturacion')">
          <span class="sidebar-item__icono"><i class="bi bi-receipt"></i></span>
          <span class="sidebar-item__texto">Facturacion</span>
          <i class="bi bi-chevron-right sidebar-grupo__chevron" :class="{ 'sidebar-grupo__chevron--abierto': expandedMenus.facturacion }"></i>
        </button>
        <transition name="desplegable">
          <div v-show="expandedMenus.facturacion" class="sidebar-submenu">
            <router-link to="/facturacion/planes-sri" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-receipt-cutoff"></i> Planes (SRI)</router-link>
          </div>
        </transition>
      </div>

      <!-- Reportes -->
      <div class="sidebar-seccion">
        <button type="button" class="sidebar-grupo" @click="toggleMenu('reportes')">
          <span class="sidebar-item__icono"><i class="bi bi-bar-chart-line"></i></span>
          <span class="sidebar-item__texto">Reportes</span>
          <i class="bi bi-chevron-right sidebar-grupo__chevron" :class="{ 'sidebar-grupo__chevron--abierto': expandedMenus.reportes }"></i>
        </button>
        <transition name="desplegable">
          <div v-show="expandedMenus.reportes" class="sidebar-submenu">
            <router-link to="/reportes/empresas" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-bar-chart"></i> Estadísticas</router-link>
            <router-link to="/reportes/ingresos" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-graph-up"></i> Ingresos</router-link>
            <router-link to="/reportes/uso" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-activity"></i> Uso</router-link>
          </div>
        </transition>
      </div>

      <!-- Configuración -->
      <div class="sidebar-seccion">
        <button type="button" class="sidebar-grupo" @click="toggleMenu('configuracion')">
          <span class="sidebar-item__icono"><i class="bi bi-gear"></i></span>
          <span class="sidebar-item__texto">Configuración</span>
          <i class="bi bi-chevron-right sidebar-grupo__chevron" :class="{ 'sidebar-grupo__chevron--abierto': expandedMenus.configuracion }"></i>
        </button>
        <transition name="desplegable">
          <div v-show="expandedMenus.configuracion" class="sidebar-submenu">
            <router-link to="/configuraciones/empresa-principal" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-building-gear"></i> Empresa principal</router-link>
            <router-link to="/configuraciones/usuarios" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-people"></i> Usuarios</router-link>
            <router-link to="/configuraciones/parametros" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-sliders"></i> Parámetros</router-link>
            <router-link to="/configuraciones/seguridad" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-shield-lock"></i> Seguridad (2FA)</router-link>
            <router-link to="/configuraciones/sri" class="sidebar-subitem" active-class="sidebar-subitem--activo"><i class="bi bi-file-earmark-text"></i> SRI</router-link>
          </div>
        </transition>
      </div>
    </nav>
  </aside>
</template>

<script>
import themeManager from '@/store/theme'

export default {
  name: 'AdminSidebar',
  data() {
    return {
      expandedMenus: {
        empresas: false,
        proveedores: false,
        controlAcceso: false,
        facturacion: false,
        reportes: false,
        configuracion: false
      }
    }
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  },
  methods: {
    toggleMenu(menuKey) {
      const estabaAbierto = this.expandedMenus[menuKey]
      // Cerrar todos los menús
      Object.keys(this.expandedMenus).forEach(k => { this.expandedMenus[k] = false })
      // Abrir el seleccionado solo si estaba cerrado
      this.expandedMenus[menuKey] = !estabaAbierto
    },
    expandActiveMenu() {
      const currentPath = this.$route.path
      if (currentPath.includes('/empresas')) {
        this.expandedMenus.empresas = true
      } else if (currentPath.includes('/control-acceso')) {
        this.expandedMenus.controlAcceso = true
      } else if (currentPath.includes('/facturacion')) {
        this.expandedMenus.facturacion = true
      } else if (currentPath.includes('/reportes')) {
        this.expandedMenus.reportes = true
      } else if (currentPath.includes('/configuracion')) {
        this.expandedMenus.configuracion = true
      }
    }
  },
  
  mounted() {
    // Expandir el menú correspondiente al cargar la página
    this.expandActiveMenu()
  },
  
  watch: {
    // Expandir el menú correspondiente al cambiar de ruta
    '$route'() {
      this.expandActiveMenu()
    }
  }
}
</script>

<style>
/* ===== SIDEBAR ===== */
.sidebar {
  background: var(--secondary-bg-main);
  border-right: 1px solid var(--border-main);
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  padding: 0;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.sidebar::-webkit-scrollbar { width: 4px; }
.sidebar::-webkit-scrollbar-track { background: transparent; }
.sidebar::-webkit-scrollbar-thumb { background: var(--border-main); border-radius: 2px; }
.sidebar::-webkit-scrollbar-thumb:hover { background: var(--text-secondary); }

/* Logo */
.sidebar-logo {
  padding: 14px 14px 12px;
  border-bottom: 1px solid var(--border-main);
  flex-shrink: 0;
}

.sidebar-logo__imagen {
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 64px;
  object-fit: contain;
  display: block;
}

/* Navegación */
.sidebar-nav {
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

/* Ítem directo */
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: background 0.18s ease, color 0.18s ease;
}

.sidebar-item:hover {
  background: var(--bg-main);
  color: var(--text-primary);
}

.sidebar-item--activo,
.sidebar-item.router-link-exact-active {
  background: rgb(14 165 233 / 0.1);
  color: var(--primary-main);
  font-weight: 600;
}

.sidebar-item__icono {
  width: 20px;
  text-align: center;
  font-size: 1rem;
  flex-shrink: 0;
}

.sidebar-item__texto {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Sección desplegable */
.sidebar-seccion {
  display: flex;
  flex-direction: column;
}

.sidebar-grupo {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 0;
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
  text-align: left;
  user-select: none;
}

.sidebar-grupo:hover {
  background: var(--bg-main);
  color: var(--text-primary);
}

.sidebar-grupo__chevron {
  margin-left: auto;
  font-size: 0.72rem;
  transition: transform 0.22s ease;
  flex-shrink: 0;
  opacity: 0.6;
}

.sidebar-grupo__chevron--abierto {
  transform: rotate(90deg);
}

/* Submenú */
.sidebar-submenu {
  margin: 2px 0 4px 20px;
  padding-left: 12px;
  border-left: 2px solid var(--border-main);
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.sidebar-subitem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.875rem;
  transition: background 0.15s ease, color 0.15s ease;
}

.sidebar-subitem:hover {
  background: var(--bg-main);
  color: var(--text-primary);
}

.sidebar-subitem--activo,
.sidebar-subitem.router-link-active {
  color: var(--primary-main);
  background: rgb(14 165 233 / 0.08);
  font-weight: 600;
}

/* Transición desplegable */
.desplegable-enter-active,
.desplegable-leave-active {
  transition: opacity 0.2s ease, transform 0.22s ease;
  transform-origin: top;
}

.desplegable-enter-from,
.desplegable-leave-to {
  opacity: 0;
  transform: scaleY(0.92) translateY(-6px);
}

.desplegable-enter-to,
.desplegable-leave-from {
  opacity: 1;
  transform: scaleY(1) translateY(0);
}
</style>
